import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import Header from './Header';
import Sidebar from './Sidebar';
import { useResponsiveSidebar } from '../../hooks/useResponsiveSidebar';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  width: 100%;
  overflow-x: hidden;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: ${({ $sidebarOpen }) => $sidebarOpen ? '280px' : '0'};
  transition: margin-left 0.3s ease-in-out;
  width: 100%;
  min-width: 0;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-left: 0;
    width: 100%;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.xl};
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

function Layout({ children }) {
  const { sidebarOpen, toggleSidebar } = useResponsiveSidebar();

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <MainContent $sidebarOpen={sidebarOpen}>
        <Header onToggleSidebar={toggleSidebar} />
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
}

export default Layout;
